import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function StockAlertsManager() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    api.get("/admin/stock-alerts").then(({ data }) => setAlerts(data)).catch(() => {});
  }, []);

  return (
    <section className="mt-20" data-testid="stock-alerts-section">
      <div className="flex items-baseline justify-between mb-6 gap-4 flex-wrap">
        <h2 className="font-serif-h font-light text-3xl text-stone-900">Back-in-Stock Requests ({alerts.length})</h2>
        <div className="text-xs tracking-overline uppercase text-stone-500">
          Customers are emailed automatically when you set stock above 0
        </div>
      </div>
      {alerts.length === 0 ? (
        <div className="text-stone-500 text-sm" data-testid="stock-alerts-empty">No pending requests.</div>
      ) : (
        <div className="border border-warm bg-white overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F3EAE8] text-[11px] tracking-overline uppercase text-stone-600">
              <tr><th className="text-left p-4">Product</th><th className="text-left p-4">Email</th><th className="text-left p-4">Requested</th></tr>
            </thead>
            <tbody>
              {alerts.map((a) => (
                <tr key={a.id} className="border-t border-warm" data-testid={`stock-alert-${a.id}`}>
                  <td className="p-4">{a.product_name}</td>
                  <td className="p-4">{a.email}</td>
                  <td className="p-4 text-stone-500">{new Date(a.created_at).toLocaleDateString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
